export const availableFileTypes = ['image/svg+xml', 'image/jpeg', 'image/png'];
